import { render, staticRenderFns } from "./ExternalProcessObject.vue?vue&type=template&id=0905c485&scoped=true&"
import script from "./ExternalProcessObject.vue?vue&type=script&lang=ts&"
export * from "./ExternalProcessObject.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalProcessObject.vue?vue&type=style&index=0&id=0905c485&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0905c485",
  null
  
)

export default component.exports